import Link from "next/link";
import * as s from "./index.module.scss";

const WatchSideBar = ({ title, links }) => {
  return (
    <div className={s.watches_sidebar}>
      <div className={s.watches_sidebar_title}>{title}</div>
      {links?.map((item, index) => (
        <div
          key={item.link?.id || index}
          className={s.item}
        >
          <Link
            href={`/what-we-buy/watch-buyers-nyc/${item.link?.uid}`}
            className={s.link}
          >
            {item.label}
          </Link>
        </div>
      ))}
    </div>
  );
};

export default WatchSideBar;
